// test1085
(1085 && 0);
